import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-lightning-import-img',
  templateUrl: './import-img.component.html',
  styleUrls: ['./import-img.component.css']
})
export class ImportImgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
